import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-chat-removed-message',
  templateUrl: './chat-removed-message.component.html',
  styleUrls: ['./chat-removed-message.component.scss']
})
export class ChatRemovedMessageComponent implements OnInit {
  @Input() isAuthorMessage = false;
  deletedText = '';

  constructor() { }

  ngOnInit(): void {
    this.deletedText = this.isAuthorMessage
    ? 'Você deletou esta mensagem.'
    : 'Esta mensagem foi deletada.';
  }

}
